module.exports = __webpack_public_path__ + "img/noData_empty_new.5a14a9f3.svg";